<template>
  <Poptip
    placement="bottom"
    popper-class="cell-batch-modify"
    trigger="click"
    v-model="visible"
    @on-popper-show="popperShow"
  >
    <Icon class="cell-batch-modify-icon" type="icon-pg-edit" />
    <div slot="content" class="cell-batch-modify-content" v-if="visible">
      <span class="cell-batch-modify-content-title">修改{{ item.label }}</span>
      <div class="cell-batch-modify-content-cont">
        <batchModifyRender
          v-model="batchValue"
          :store="store"
          :extendData="extendData"
          :editformItem="item"
          :disabled="disabled"
        />
      </div>
      <div class="cell-batch-modify-content-footer">
        <Button type="primary" shape="circle" @click="setTableData()">设置所有行</Button>
        <Button type="primary" shape="circle" @click="setTableData('space')">仅设置空行</Button>
        <Button type="error" shape="circle" @click="setTableData('remove')">清空所有行</Button>
      </div>
    </div>
  </Poptip>
</template>
<script setup>
import { ref } from 'vue'
import batchModifyRender from './batchModifyRender'
import objectUtil from '../../../static/js/objectUtil'

const props = defineProps({
  item: Object,
  store: {
    type: Object,
    default: null,
  },
  extendData: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  batchRow: Function,
  tableData: Array,
})
const visible = ref(false)

const batchValue = ref(null)

const popperShow = () => {
  batchValue.value = null
}
//type 无值表示修改所有行， 为space时表示修改为空的行，remove表示清空所有行
const setTableData = async (type) => {
  if (props.batchRow) {
    await props.batchRow(type, props.item.property, type === 'remove' ? null : batchValue.value)
  } else if (props.tableData) {
    for (const row of props.tableData) {
      if (type === 'remove') {
        objectUtil.setValueByPath(row, props.item.property, null)
      } else if (type === 'space') {
        const oldValue = objectUtil.getValueByPath(row, props.item.property)
        if (!oldValue && oldValue !== 0 && oldValue !== false) {
          objectUtil.setValueByPath(row, props.item.property, batchValue.value)
        }
      } else {
        objectUtil.setValueByPath(row, props.item.property, batchValue.value)
      }
    }
  }

  visible.value = false
}
</script>
